// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "fit-em-30.firebaseapp.com",
  "projectId": "fit-em-30",
  "storageBucket": "fit-em-30.appspot.com",
  "messagingSenderId": "277643824772",
  "appId": "1:277643824772:web:64189ad5691e140ace7cd1",
  "measurementId": "G-79N645WKCX",
  "apiKey": "AIzaSyBwZd93CW5b0uxA0P_wPh1puPwt6nuafBw"
};
